import { createAction } from 'typesafe-actions'
import { Call, Endpoint, Line, Settings, VideoSourceType } from '../model'

export const initApp = createAction('INIT_APP')()

export const endpointStatusChanged = createAction('ENDPOINT_STATUS_CHANGED')<Endpoint>()
export const connectEndpoint = createAction('CONNECT_ENDPOINT', (extension: string, pin: string) => ({ extension, pin }))()
export const connectEndpointGuest = createAction('CONNECT_ENDPOINT_GUEST', (guestId: string, guestPasskey: string, displayName: string) => ({ guestId, guestPasskey, displayName }))()
export const disconnectEndpoint = createAction('DISCONNECT_ENDPOINT')()
export const configureEndpoint = createAction('CONFIG_ENDPOINT')<Settings>()

export const lineStatusChanged = createAction('LINE_STATUS_CHANGED')<Line>()
// export const register = createAction('REGISTER')()
// export const unregister = createAction('UNREGISTER')()

export const configureMediaConstraints = createAction('CONFIGURE_MEDIA_CONSTRAINTS')<MediaTrackConstraints>()
export const configureSecondaryRinger = createAction('CONFIGURE_SECONDARY_RINGER')<string>()

export const callStatusChanged = createAction('CALL_STATUS_CHANGED', (focusCallIndex: number, calls: Call[]) => ({ focusCallIndex, calls }))()
export const dial = createAction('DIAL')<string>()
export const hangUp = createAction('HANG_UP')()
export const muteMicrophone = createAction('MUTE_MICROPHONE', (mute: boolean) => mute)()
export const muteSpeaker = createAction('MUTE_SPEAKER', (mute: boolean) => mute)()
export const dtmf = createAction('DTMF')<string>()
export const answer = createAction('ANSWER')()
export const hold = createAction('HOLD')()
export const resume = createAction('RESUME')()
export const toggleVideo = createAction('TOGGLE_VIDEO', (enable: boolean, videoSource?: VideoSourceType) => ({ enable, videoSource }))()
export const setVideoPan = createAction('SET_VIDEO_PAN')<number>()
export const setVideoTilt = createAction('SET_VIDEO_TILT')<number>()
export const setVideoZoom = createAction('SET_VIDEO_ZOOM')<number>()
export const transfer = createAction('TRANSFER')()
export const getCallStats = createAction('CALL_GET_STATS')()
